import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IBase } from 'src/app/models';
import { LiteralService } from 'src/app/services/literal/literal.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { images } from 'src/images';
import { TooltipPosition } from '../tooltip/tooltip-position';
import { InputType } from 'src/app/models/enums';
import { ServiceTagComponent } from 'src/app/components/service-tag/service-tag.component';
import { BookingSeatsComponent } from 'src/app/components/booking/booking-seats/booking-seats.component';
import { ColorComponent } from 'src/app/components/color/color.component';
import moment from 'moment';
import { CheckboxComponent, ConvertibleSeatsInputComponent, ToggleComponent } from '../input';
import { StorageService } from 'src/app/services';
import { APP } from 'src/app/config/app';

import { CommonModule } from '@angular/common';
import { TooltipModule } from '../tooltip/tooltip.module';
@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  imports: [
    CommonModule,
    TooltipModule,
    BookingSeatsComponent,
    ColorComponent,
    ConvertibleSeatsInputComponent,
    ServiceTagComponent,
    ToggleComponent,
  ],
  styleUrls: ['./detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DetailComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() value?: any;
  @Input() extendable: boolean;

  public images = images;
  public textValues = '';
  public text = '';

  public editable = false;

  public moment = moment;
  public TooltipPosition = TooltipPosition;
  public InputType = InputType;
  public ServiceTagComponent = ServiceTagComponent;
  public BookingSeatsComponent = BookingSeatsComponent;
  public ColorComponent = ColorComponent;
  public ToggleComponent = ToggleComponent;
  public CheckboxComponent = CheckboxComponent;
  public ConvertibleSeatsInputComponent = ConvertibleSeatsInputComponent;
  
  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
    private changeDetectorRef: ChangeDetectorRef,
    private storageService: StorageService,
  ) {}

  async ngOnInit() {
    this.data.array ? this.getTextFromArray() : this.getText();
    // this.data.array ? this.textValues = this.utilsService.getTextFromArray(this.data.value, this.textValues, this.data.value, this.translateValue!) || ''; : this.getText();
    this.changeDetectorRef.detectChanges();
    this.editable = await this.showDetailsForEdit();
  }

  ngOnChanges(): void {
    this.data.array ? this.getTextFromArray() : this.getText();
    this.changeDetectorRef.detectChanges();
  }

  getText() {
    this.text = '';
    this.text = this.data.value;
  }

  getTextFromArray() {
    this.textValues = '';

    if (!this.data.value?.length) {
      this.textValues = '-';
      return;
    }

    this.data.value.sort((a: IBase, b: IBase) => a.id! - b.id!);

    this.textValues =
      this.data.value
        .map((value: any) =>
          this.literalService.get(
            value[this.data.dataToShow] ||
              value.name ||
              value.id ||
              value.label ||
              value,
            true,
          ),
        )
        .join(', ') || '-';
  }

  getTextColor(color: string) {
    if (!color) return '';
    // If it's a predefined color, get the translation
    if (APP.PREDEFINED_COLORS.has(color)) {
      return this.literalService.get(`colors.${color}`, true);
    }
    // Custom color - just show the hex value
    return color;
  }

  async showDetailsForEdit() {
    const routeName = await this.storageService.getRouteName();
    // TODO: Uncomment this when we use me/permissions
    // return routeName === 'bookings' && this.roleService.permissions['RESERVATION']['UPDATE'];
    return routeName === 'bookings';
  }
}
